<template>
  <div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'ResetPassword',
  data () {
    return {
      password: ''
    }
  },
  mounted: function () {
    let token = this.$route.params.token
    this.$http.post(this.apiurl + 'api/resetpassword', {
      token: token
    }).then(function (res) {
      let status = res.body.status
      if (status === 200) {
      } else {
        window.alert('您輸入的帳號或密碼錯誤，請重新輸入。')
      }
    }, function () {
      console.log('failed')
    })
  },
  methods: {
    ...mapActions([
      'getCompanies'
    ])
  },
  computed: {
    ...mapGetters([
      'getAPI'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?317fba8b